import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { AngularFireAuth } from 'angularfire2/auth';
import * as firebase from 'firebase/app';
import { Observable } from 'rxjs/Observable';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { environment } from '../../environments/environment';

@Component({
  selector: 'ns-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})

export class LoginComponent {
  loginForm: FormGroup;
  passwordChar1Ctrl: FormControl;
  passwordChar2Ctrl: FormControl;
  passwordChar3Ctrl: FormControl;
  passwordChar4Ctrl: FormControl;
  passwordChar5Ctrl: FormControl;
  passwordChar6Ctrl: FormControl;
  loginAnimation = false;
  isLoading = false;
  hasError = false;

  user: Observable<firebase.User>;
  private email = 'jeremydelacasa2@gmail.com';

  constructor(
    fb: FormBuilder,
    public afAuth: AngularFireAuth,
    private router: Router
  ) {
    this.user = afAuth.authState;
    this.passwordChar1Ctrl = fb.control('', Validators.required);
    this.passwordChar2Ctrl = fb.control('', Validators.required);
    this.passwordChar3Ctrl = fb.control('', Validators.required);
    this.passwordChar4Ctrl = fb.control('', Validators.required);
    this.passwordChar5Ctrl = fb.control('', Validators.required);
    this.passwordChar6Ctrl = fb.control('', Validators.required);

    this.loginForm = fb.group({
      passwordChar1: this.passwordChar1Ctrl,
      passwordChar2: this.passwordChar2Ctrl,
      passwordChar3: this.passwordChar3Ctrl,
      passwordChar4: this.passwordChar4Ctrl,
      passwordChar5: this.passwordChar5Ctrl,
      passwordChar6: this.passwordChar6Ctrl,
    })
    this.afAuth.auth.signOut();
  }

  login() {
    this.isLoading = true;
    let self = this;
    let values = this.loginForm.value;
    let password = '' + values.passwordChar1 + values.passwordChar2 + values.passwordChar3 + values.passwordChar4 + values.passwordChar5 + values.passwordChar6;
    this.afAuth.auth.signInWithEmailAndPassword(this.email, password).then(result => {
      if(result) {
        this.hasError = false;
        this.loginAnimation = true;
        setTimeout(function(){
          self.router.navigate(['/']);
        },3500);
      }
    })
    .catch(function(error) {
      var errorCode = error['code'];
      var errorMessage = error.message;
      if(errorCode == 'auth/wrong-password') {
        console.log('Wrong password.');
      } else {
        console.log(errorMessage);
      }
      console.log(error);
      self.isLoading = false;
      self.hasError = true;
    });
  }

  getLength(event, next, prev) {
    let value = parseInt(event.target.value);
    if(this.hasError) {
      this.hasError = false;
    }

    if(!Number.isInteger(value)) {
      event.target.value = '';
    }

    if(event.target.value.length >= event.target.maxLength && next !== undefined) {
      if(event.target.value.length > 1) {
        event.target.value = '';
      } else {
        next.focus();
      }

    }else if(event.key === 'Backspace' && prev !== undefined){
      if(event.target.value.length === 0) {
        prev.focus();
      }
    } else if(next === undefined || prev === undefined) {
      if(event.target.value.length > 1) {
        event.target.value = '';
      }
    }
  }

  hasErrorFn() {
    return this.hasError;
  }

  isLoadingFn() {
    return this.isLoading;
  }

}



// WEBPACK FOOTER //
// /Users/mac-jeremy/Projets/fairepart/src/app/login/login.component.ts